import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToasterComponent } from './toaster.component';
import { ToasterListComponent } from './components/toaster-list/toaster-list.component';

@NgModule({
  declarations: [ToasterComponent],
  imports: [CommonModule, ToasterListComponent],
  exports: [ToasterComponent],
})
export class ToasterModule {}
